/***
 * @function :ModeratorCard
 * @description :
 */

import React from "react";
import { Card, Image } from "react-bootstrap";

const ModeratorCard = (props) => {
  const { moderator_data } = props;

  return (
    <div className="common_card">
      <Card>
        <Card.Header>
          <div className="row">
            <div className="col-12 d-flex">
              {moderator_data?.profile_picture_url.length > 0 ? (
                <Image
                  src={moderator_data?.profile_picture_url[0]}
                  roundedCircle
                  className="profile-container"
                />
              ) : (
                <div className="profile-container no-image">
                  {moderator_data.first_name.charAt(0)}
                  {moderator_data.last_name
                    ? moderator_data.last_name.charAt(0)
                    : ""}
                  {/* SA */}
                </div>
              )}
              <div className="text-left px-3">
                <p className="label">Name</p>
                <p className="description">
                  {/* Dr. Suganya Anandaraman */}
                  {moderator_data.prefix_name} {moderator_data.first_name}{" "}
                  {moderator_data.middle_name} {moderator_data.last_name}
                </p>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          {moderator_data && moderator_data.designation ? (
            <div className="text-left mb-3">
              <p className="label">Designation</p>
              <p className="description">
                {/* Doctor */}
                {moderator_data && moderator_data.designation
                  ? moderator_data.designation
                  : "-"}
              </p>
            </div>
          ) : null}
          {moderator_data && moderator_data.about ? (
            <div className="text-left mb-3">
              <p className="label">About the moderator</p>
              <p className="description">
                {/* I am moderator */}
                {moderator_data && moderator_data.about
                  ? moderator_data.about
                  : "-"}
              </p>
            </div>
          ) : null}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ModeratorCard;
